export const MAX_FILE_SIZE_RULE_NAME = "max_file_size";
/**
 * Validates that a file is not larger than a maximum size.
 */
export const Validator = {
    name: MAX_FILE_SIZE_RULE_NAME,
    errorMessage: `The file is too large. Maximum file size is :${MAX_FILE_SIZE_RULE_NAME} MB.`,
    validate: (value, requirement) => {
        const maxFileSizeInMB = parseInt(requirement, 10);
        // Handle File for FileUploadField
        if (value instanceof File) {
            return bytesToMegaBytes(value.size) <= maxFileSizeInMB;
        }
        // Handle base64 string in for SnapshotField (Image)
        if (typeof value === "string") {
            const approximateBase64SizeInBytes = 3 * (String(value).length / 4);
            return bytesToMegaBytes(approximateBase64SizeInBytes) <= maxFileSizeInMB;
        }
        // The value is a link to existing FileReference, no need to check for maximum file size.
        return true;
    },
};
const bytesToMegaBytes = (bytes) => bytes / 1024 / 1024;
